// Define the types for the component props
interface TextInputProps {
  Name?: string;
  Placeholder?: string;
  Value?: string;
  Type?: string;
  Capitalize?: boolean;
  onChange?: (value: string) => void;
}

export default function TextInput({
  Name = "input name",
  Placeholder = "enter the name",
  Type = "text",
  Value = "",
  Capitalize = true,
  onChange = () => {},
}: TextInputProps) {
  return (
    <div className="space-y-2">
      <p className="capitalize font-primary">{Name}</p>
      <input
        className={`w-full outline-none border p-2 rounded px-4 ${Capitalize && "capitalize"}`}
        placeholder={Placeholder}
        value={Value}
        type={Type}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
